<template>
    <div id="transaction-history">
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Monthly Statement') }}</h3>
                <span class="fz-16 fw-400">{{ $t('View your statements here') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <b-row class="pt-3">
                <b-col cols="12">

                    <div class="block-item p-3 w-100 mb-4"
                        style="margin-top:-100px;box-shadow: 0px 5px 10px 0px #0000000D;">
                        <b-row class="align-items-end">
                            <b-col cols="12" md="4" lg="5">
                                <label>{{ $t('Transaction Date') }} :</label>
                                <date-picker v-model="search.date" type="month"
                                    value-type="YYYY-MM-DD" :editable="false" :placeholder="$t('Select Month')"
                                    :lang="getLocalizationsDate()"></date-picker>
                            </b-col>

                            <b-col cols="12" md="4" lg="5">
                                <label>{{ $t('Currency') }} :</label>
                                <select class="form-control" v-model="search.ccy">
                                    <option value="" selected>-- All --</option>
                                    <option :value="item" v-for="item in currencyList">{{ item }}</option>
                                </select>
                            </b-col>

                            <b-col cols="12" md="4" lg="2">
                                <button class="btn btn-primary w-100 mb-0 mt-3 mt-md-0" :disabled="isSearchDisabled"
                                    @click="doFilter">{{ $t('Search') }}</button>
                            </b-col>
                        </b-row>
                    </div>

                    <!-- IFRAME bank-statement.html -->
                    <div v-show="isShowIframe" id="body-container" class="w-100 mb-4 mt-0 position-relative">
                        <b-embed class="iframe" type="iframe" :src="'bank-statements-live.html?v='+nocacheVersion" allowfullscreen></b-embed>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import enEN from 'vue2-datepicker/locale/en';
import zhCN from 'vue2-datepicker/locale/zh-cn';
import zhTW from 'vue2-datepicker/locale/zh-tw';
import jaJA from 'vue2-datepicker/locale/ja';

import LoaderComponent from "@/components/LoaderComponent";

import Account from '@/services/Account';
import CreateAccount from '@/services/CreateAccount';
import Transaction from '@/services/Transaction';
import Common from '@/services/Common';

const USER_TYPE = {
    2: "China Enterprise",
    3: "Hong Kong Enterprise",
    5: "International Enterprise"
}

export default {
    name: "bank statements",
    data() {
        return {
            publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
            isDebug: process.env.VUE_APP_DEBUG_MODE,
            userListDebug: process.env.VUE_APP_LIST_USER_DEBUG,
            nocacheVersion: process.env.VUE_APP_NOCACHE_VERSION,
            isLoading: false,
            tmpCurrencyList: [],
            currencyList: [
            ],
            dataAccount: null,
            search: {
                date: '',
                ccy: '',
            },
            isShowIframe: false,
            bankStatement: {
                'company': null,
                'statements': null,
                'from_date': null,
                'to_date': null,
                'currency': null,
                't_download_pdf': this.$t('Download PDF'),
            },
        };
    },
    components: {
        DatePicker, LoaderComponent,
    },
    computed: {
        isSearchDisabled() {
            return !this.search.date || !this.search.ccy;
        }
    },
    methods: {
        getLocalizationsDate() {
            const valueLang = localStorage.getItem("lang");

            if (valueLang) {
                if (valueLang === 'zh-CN') {
                    const customZh = {
                        ...zhCN,
                        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                        monthsShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                    };
                    return customZh;
                } else if (valueLang === 'zh-TW') {
                    const customTw = {
                        ...zhTW,
                        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                        monthsShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                    };
                    return customTw;
                } else if (valueLang === 'ja-JA') {
                    return jaJA;
                } else {
                    return enEN;
                }
            } else {
                return enEN;
            }
        },
        disabledDate(date) {
            const startAprilDate = new Date();
            startAprilDate.setFullYear(2025, 3, 1);
            startAprilDate.setHours(0, 0, 0, 0);
            return date < startAprilDate;
        },
        getTransaction() {
            const self = this;
            Transaction.availableCurrency().then((response) => {
                if (response.status == 200) {
                    const responseData = response.data;
                    const data = responseData.data;

                    if (data) {
                        const usedCurrencies = new Set(data.map(item => item))
                        console.log(usedCurrencies);
                        self.currencyList = data;

                        for (let i = self.tmpCurrencyList.length - 1; i >= 0; i--) {
                            const ccy = self.tmpCurrencyList[i];
                            if (usedCurrencies.has(ccy)) {
                                self.tmpCurrencyList.splice(i, 1);
                            }
                        }
                    }

                    self.getBalances();
                } else {
                    self.isLoading = false;
                }
            })
                .catch((err) => {
                    self.checkError(err);
                });
        },
        getBalances() {
            const self = this;
            
            self.tmpCurrencyList.map(ccy => {
                return Account.getBalance({
                    "userNo": self.dataAccount.userNo,
                    "ccy": ccy
                }).then((response) => {
                    const data = response.data.data.data;

                    if (data) {
                        const balance = data.availableBal;
                        if (balance > 0) {
                            self.currencyList.push(ccy);
                        }
                    }
                });
            });
        },
        getAccount() {
            const self = this;
            CreateAccount.list({
                search: self.search,
                start: 0,
                length: -1
            }).then((response) => {
                if (response.status == 200) {
                    const responseData = response.data;
                    self.dataAccount = responseData.data[0];

                    if (self.dataAccount) {
                        const userType = self.dataAccount.userType;

                        if (userType == 5) {
                            self.bankStatement.company = {
                                'province': self.dataAccount.information.registerProvince,
                                'city': self.dataAccount.information.registerCity,
                                'district': self.dataAccount.information.registerArea,
                                'address' : self.dataAccount.information.registerAddress
                            };
                        }

                        self.getSubAccount();
                    } else {
                        self.isLoading = false;
                    }
                } else {
                    self.isLoading = false;
                }
            }).catch((err) => {
                self.checkError(err);
            });
        },
        getSubAccount() {
            let self = this;
            CreateAccount.listSubAccount({
                start: 0,
                length: -1,
                search: { value: self.dataAccount.userNo }
            }).then((response) => {
                if (response.status == 200) {
                    const responseData = response.data;

                    if (responseData.data.length > 0) {
                        const data = responseData.data[0];

                        if (data) {
                            // passing list currency
                            self.tmpCurrencyList = data.currency.split(',');
                            
                            self.bankStatement.company = {
                                ...self.bankStatement.company,
                                'account_name': self.dataAccount.information.enName,
                                'address': self.dataAccount.information.registerAddress,
                                'account_type': USER_TYPE[self.dataAccount.userType],
                                'bank_account_name': data.bankAccountName,
                                'bank_name': data.bankName,
                                'bank_address': data.bankAddress,
                                'bank_code': data.bankCode,
                                'branch_code': data.bankSubCode,
                                'account_no': data.bankNo,
                                // 'open_date': data.created_at ? moment(data.created_at).format('DD/MM/YYYY') : null,
                            };

                            switch (self.dataAccount.userType) {
                                case 2:
                                    self.getProvince('CHN');
                                    break;
                                case 3:
                                    self.getProvince('HKG');
                                    break;
                                default:
                                    const countryCode = self.dataAccount.information.registerCountry;
                                    self.getCountry(countryCode);
                                    break;
                            }

                            self.getTransaction();
                        } else {
                            self.isLoading = false;
                        }
                    } else {
                        self.isLoading = false;
                    }
                } else {
                    self.isLoading = false;
                }
            }).catch((err) => {
                self.checkError(err);
            });
        },
        getCountry(countryCode) {
            let self = this;
            Common.countriesByCode({ "country_code": countryCode }).then(response => {
                const data = response.data.data;

                if (response.status == 200) {
                    if (data) {
                        self.bankStatement.company.country = data[0].name;
                    }
                }

                self.isLoading = false;
            }).catch(err => {
                self.checkError(err);
            });
        },
        getProvince(countryCode) {
            let self = this;

            CreateAccount.getProvince({ "country": countryCode }).then(response => {
                const data = response.data.data;

                if (response.status == 200) {
                    if (data) {
                        const information = self.dataAccount.information;

                        if (information) {
                            if (self.dataAccount.userType !== 5) {
                                // find province
                                const idRegisterProvince = information.registerProvince.split('_')[0];
                                const dataProvince = data.find(item => item.id == idRegisterProvince);
                                if(dataProvince){
                                    self.bankStatement.company.province = dataProvince.english_text;

                                    if (idRegisterProvince) {
                                        self.getCity(idRegisterProvince);
                                    } else {
                                        self.isLoading = false;
                                    }
                                }
                                else{
                                    self.bankStatement.company.province = "";
                                    self.bankStatement.company.city = "";
                                    self.bankStatement.company.district = "";
                                    self.isLoading = false;
                                    self.isLoading = false;   
                                }
                            } else {
                                self.bankStatement.company.province = information.registerProvince;
                                self.bankStatement.company.city = information.registerCity;
                                self.bankStatement.company.district = information.registerArea;
                                self.isLoading = false;
                            }
                        } else {
                            self.isLoading = false;
                        }
                    } else {
                        self.isLoading = false;
                    }
                } else {
                    self.isLoading = false;
                }
            }).catch(err => {
                this.checkError(err);
            });
        },
        getCity(provinceCode) {
            let self = this;
            CreateAccount.getCity({ "province_id": provinceCode }).then(response => {
                const data = response.data.data;

                if (response.status == 200) {
                    if (data) {
                        const information = self.dataAccount.information;
                        if (information) {
                            // find city
                            const idRegisterCity = information.registerCity.split('_')[0];
                            const dataCity = data.find(item => item.code == idRegisterCity);
                            self.bankStatement.company.city = dataCity.english_text;

                            if (idRegisterCity) {
                                self.getDistrict(idRegisterCity);
                            } else {
                                self.isLoading = false;
                            }
                        } else {
                            self.isLoading = false;
                        }
                    } else {
                        self.isLoading = false;
                    }
                } else {
                    self.isLoading = false;
                }
            }).catch(err => {
                self.checkError(err);
            });
        },
        getDistrict(cityCode) {
            let self = this;
            CreateAccount.getDistrict({ "city_id": cityCode }).then(response => {
                const data = response.data.data;

                if (response.status == 200) {
                    if (data) {
                        const information = self.dataAccount.information;
                        if (information) {
                            // find district
                            const idRegisterDistrict = information.registerArea.split('_')[0];
                            const dataDistrict = data.find(item => item.id == idRegisterDistrict);
                            self.bankStatement.company.district = dataDistrict.english_text;
                        }
                    }
                }

                self.isLoading = false;
            }).catch(err => {
                self.checkError(err);
            });
        },
        getBankStatement() {
            const self = this;
            Transaction.statements(self.search).then((response) => {
                if (response.status == 200) {
                    const responseData = response.data.data;
                    
                    //if (responseData.transactions.length>0) {
                        if(parseFloat(responseData.opening_balance)>0){
                            const firstTransaction = moment(self.search.date).startOf('month').format('YYYY-MM-DD');

                            const createdTime = moment(firstTransaction, 'YYYY-MM-DD HH:mm:ss')
                            const lastDateOfPreviousMonth = createdTime.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')

                            const openingTransaction = {
                                id: -1,
                                trans_no: "",
                                userno: firstTransaction.userno,
                                account_id: firstTransaction.account_id,
                                currency: firstTransaction.currency,
                                amount: "",
                                data_type: "",
                                entity_type: "",
                                entity_id: null,
                                created_by: 0,
                                created_time: lastDateOfPreviousMonth,
                                updated_by: null,
                                updated_time: null,
                                balance: responseData.opening_balance,
                                balance_outstanding: responseData.opening_balance,
                                description: "承上結餘 Balance Brought Forward"
                            };

                            responseData.transactions.unshift(openingTransaction);
                        }

                        self.bankStatement.statements = responseData;
                        self.bankStatement.from_date = moment(self.search.date).startOf('month').format('DD/MM/YYYY');
                        self.bankStatement.to_date = moment(self.search.date).endOf('month').format('DD/MM/YYYY');
                        self.sendFilterToIframe();
                    //}
                }

                self.isLoading = false;
            })
                .catch((err) => {
                    self.checkError(err);
                });
        },
        doFilter() {
            const self = this;
            self.isLoading = true;
            self.isShowIframe = false;
            self.bankStatement.currency = self.search.ccy;
            self.getBankStatement()
        },
        sendFilterToIframe() {
            const self = this;
            const iframe = document.querySelector('iframe');
            iframe.contentWindow.postMessage({ type: 'RENDER', data: self.bankStatement }, '*');
            self.isShowIframe = true;
        },
        checkError(err) {
            this.isLoading = false;
            const response = err.response;
            try {
                if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: '/login',
                    });
                }
                else {
                    if (localStorage.getItem("token")) {
                        var msg = (response.data) ? response.data.message : err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            } catch (e) {
                console.log(err);
            }
        },
        getProfile() {
            Common.profile().then((response) => {
                if (response.status == 200 && response.data.success) {
                    const profile = response.data.data;

                    if (
                    (this.userListDebug.includes(profile.username) && this.isDebug == 1)
                    ) {
                        this.$router.push({ 
                            path: '/statements', 
                        });
                    }
                }
            });
        }
    },

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.isLoading = true;
            self.getProfile();
            self.getAccount();

        });
    },
};
</script>

<style>
#body-container {
    height: 1000px;
}

.mx-datepicker .mx-input {
    height: 48.4px !important;
    line-height: 40px;
    font-size: 16px;
    padding: 8px 12px;
    border-radius: 8px;
}

.embed-responsive {
    height: 100%;
}

.iframe {
    display: block !important;
}
</style>